import React from "react";
import { Navigate, useLocation } from "react-router-dom";

const AuthGuard = ({ children }) => {
  const location = useLocation();
  
  const id = localStorage.getItem("id");
  const email = localStorage.getItem("email");
  const username = localStorage.getItem("nombre");
  const userRole = localStorage.getItem("rol");

  const isAuthenticated = id && email && username && userRole;


  if (!isAuthenticated) {
    return <Navigate 
      to="/signin" 
      state={{ from: location, requireAuth: true }} 
      replace 
    />;
  }

  return children;
};

export default AuthGuard;